import { IconType, SvgIcon } from './SvgIcon';

export const ExclamationTriangleIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M22.7037 17.4994L14.6037 3.49938C13.8037 2.09938 11.9037 1.59938 10.5037 2.39938C10.0037 2.69938 9.60367 3.09938 9.40367 3.49938L1.30367 17.4994C0.503674 18.8994 1.00367 20.7994 2.40367 21.5994C2.90367 21.8994 3.40367 21.9994 3.90367 21.9994H20.0037C21.7037 21.9994 23.0037 20.5994 23.0037 18.9994C23.1037 18.3994 22.9037 17.8994 22.7037 17.4994ZM12.0037 17.9994C11.4037 17.9994 11.0037 17.5994 11.0037 16.9994C11.0037 16.3994 11.4037 15.9994 12.0037 15.9994C12.6037 15.9994 13.0037 16.3994 13.0037 16.9994C13.0037 17.5994 12.6037 17.9994 12.0037 17.9994ZM13.0037 12.9994C13.0037 13.5994 12.6037 13.9994 12.0037 13.9994C11.4037 13.9994 11.0037 13.5994 11.0037 12.9994V8.99938C11.0037 8.39938 11.4037 7.99938 12.0037 7.99938C12.6037 7.99938 13.0037 8.39938 13.0037 8.99938V12.9994Z"
      fill="currentColor"
    />
  </SvgIcon>
);

ExclamationTriangleIcon.displayName = 'ExclamationTriangleIcon';
